type Props = {
  title: string;
  label: string;
  body: string;
};

const Blurb = ({ title, label, body }: Props) => {
  return (
    <div className="border-neutral-light border p-8 font-serif font-extralight">
      <span className="mb-4 block text-xs">{label}</span>
      <h3 className="mb-6 block text-xl">{title}</h3>
      <p className="text-secondary text-base text-balance">{body}</p>
    </div>
  );
};

export default Blurb;
